import React from 'react';
import { Global, css } from '@emotion/react';

import Lato from '../assets/fonts/lume/Lato-Normal.woff';
import Lato2 from '../assets/fonts/lume/Lato-Normal.woff2';
import LatoLight from '../assets/fonts/lume/Lato-Light.woff';
import Playfair from '../assets/fonts/haven/PlayfairDisplay-VariableFont_wght.woff';
import PlayfairItalic from '../assets/fonts/haven/PlayfairDisplay-Italic-VariableFont_wght.woff';

const GlobalStyle = () => {
  const styles = css`

   @font-face {
      font-display: swap;
      font-family: 'Lato';
      src: url(${Lato2}) format('woff2'), url(${Lato}) format('woff');
      font-style: normal;
      font-weight: 400;
    }

    @font-face {
      font-display: swap;
      font-family: 'Lato-Light';
      src: url(${LatoLight}) format('woff');
      font-style: normal;
      font-weight: 500;
      unicode-range: U+0000-00FF, U+2018-2019, U+201C-201D;
    }

    @font-face {
      font-display: swap;
      font-family: 'Playfair';
      src: url(${Playfair}) format('woff');
      font-style: normal;
      font-weight: 500;
      unicode-range: U+0000-00FF, U+2018-2019, U+201C-201D;
    }

    @font-face {
      font-display: swap;
      font-family: 'PlayfairItalic';
      src: url(${PlayfairItalic}) format('woff');
      font-style: normal;
      font-weight: 500;
      unicode-range: U+0000-00FF, U+2018-2019, U+201C-201D;
    }
  `;

  return <Global styles={styles} />;
};

export default GlobalStyle;
